import { isRecommendationsSection } from '../typeGuards';
// eslint-disable-next-line import/no-cycle
import { CONSTANTS, storeRecentSearch, storeRecentAction } from './beaconUtils';
import { storageSetItem, storageRemoveItem } from './storage';
export function isTrackingRequestSent(trackingRequestUrl) {
    // eslint-disable-next-line
    const trackingRequestsQueue = window.localStorage?._constructorio_requests;
    return (trackingRequestsQueue &&
        JSON.parse(trackingRequestsQueue)?.some((request) => request?.url?.includes(trackingRequestUrl)));
}
export const trackRecommendationView = (target, activeSectionsWithData, cioClient) => {
    if (target.dataset.cnstrcRecommendationsPodId) {
        // Pull recommendations from activeSectionsWithData by podId surfaced on target
        const recommendationSection = activeSectionsWithData.find((section) => isRecommendationsSection(section) &&
            section.podId === target.dataset.cnstrcRecommendationsPodId);
        const recommendationItems = recommendationSection?.data.map((item) => ({
            itemId: item.data?.id,
            itemName: item.value,
            variationId: item.data?.variation_id,
        }));
        cioClient?.tracker.trackRecommendationView({
            podId: target.dataset.cnstrcRecommendationsPodId,
            numResultsViewed: recommendationItems?.length || 0,
            url: window.location.href,
            section: target.dataset.cnstrcSection,
            items: recommendationItems,
        });
    }
};
export const trackSearchSubmit = (cioClient, term, autocompleteData = {}) => {
    cioClient?.tracker.trackSearchSubmit(term, autocompleteData);
    storageSetItem(CONSTANTS.SEARCH_TERM_STORAGE_KEY, term);
    storeRecentSearch(term, {});
    storeRecentAction(CONSTANTS.SEARCH_SUBMIT);
};
export const trackAutocompleteSelect = (cioClient, itemName, autocompleteData = {}) => {
    cioClient?.tracker.trackAutocompleteSelect(itemName, autocompleteData);
    if (autocompleteData?.section === 'Products') {
        storageRemoveItem(CONSTANTS.SEARCH_TERM_STORAGE_KEY);
    }
};
export const trackRecommendationSelect = (cioClient, recommendationData = {}) => {
    storageRemoveItem(CONSTANTS.SEARCH_TERM_STORAGE_KEY);
    cioClient?.tracker.trackRecommendationClick(recommendationData);
};
export const captureTrackingRequest = async (urlPattern, action) => {
    let trackingCaptured = false;
    const originalSetItem = Storage.prototype.setItem;
    Storage.prototype.setItem = function setItemInterceptor(key, value) {
        if (key === '_constructorio_requests') {
            try {
                const requests = JSON.parse(value);
                if (requests.some((req) => req?.url?.includes(urlPattern))) {
                    trackingCaptured = true;
                }
            }
            catch (e) {
                // Ignore parsing errors
            }
        }
        return originalSetItem.call(this, key, value);
    };
    await action();
    Storage.prototype.setItem = originalSetItem;
    return trackingCaptured || isTrackingRequestSent(urlPattern);
};
